import { render, staticRenderFns } from "./shikkadood.vue?vue&type=template&id=7de13142"
import script from "./shikkadood.vue?vue&type=script&lang=js"
export * from "./shikkadood.vue?vue&type=script&lang=js"
import style0 from "./shikkadood.vue?vue&type=style&index=0&id=7de13142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports